import React from "react";
import Box from "@mui/material/Box";
import Snackbar from "@mui/material/Snackbar";
import Fade from "@mui/material/Fade";

export const NotificationSnackBar: React.FC<{ message: string }> = ({
  message,
}) => {
  const vertical = "bottom";
  const horizontal = "right";

  return (
    <Box sx={{ width: 500 }}>
      <Snackbar
        sx={{
          backgroundColor: "#012c3b",
          color: "white",
        }}
        anchorOrigin={{ vertical, horizontal }}
        open={message !== undefined}
        autoHideDuration={2000}
        message={message}
        key={vertical + horizontal}
        TransitionComponent={Fade}
      />
    </Box>
  );
};
